<template>
    <div>
        <v-card class="p-3">
            <div class="d-flex justify-content-between">
                <h5 v-if="!vtUse">Informations</h5>
                <div class="d-flex" v-else>
                    <div class="category-btn mr-3" v-if="informationData && informationData.provider_category">
                        {{ informationData.provider_category }}
                    </div>

                    <div class="page-title mr-3" v-if="informationData && informationData.provider_name">
                        {{ informationData.provider_name }}
                    </div>

                    <div v-if="informationData && informationData.provider_apidae_external_id">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on"
                                       :href="'https://base.apidae-tourisme.com/gerer/objet-touristique/' +
                                       informationData.provider_apidae_external_id + '/consulter/'"
                                       target="_blank"
                                       class="shadow-none bg-white">
                                    <v-icon>open_in_new</v-icon>
                                </v-btn>
                            </template>
                            <span>Voir sur Apidae</span>
                        </v-tooltip>
                    </div>
                </div>

                <div class="d-flex justify-content-between gap-10" v-if="account.tis_type.code === 'DAHUB_QUEBEC'">
                    <v-tooltip top v-if="informationData && informationData.sit_draft">
                        <template v-slot:activator="{ on }">
                            <v-btn outlined class="custom-button-primary"
                                   style="height: 36px;min-width: 42px;padding: 0"
                                   @click="prepareDraft" v-on="on"
                            >
                                <v-icon color="error">edit</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            Brouillon en cours par {{ informationData.sit_draft.user.first_name }}
                            {{ informationData.sit_draft.user.last_name }} ({{ formatDate(informationData.sit_draft.date) }})
                        </span>
                    </v-tooltip>

                    <v-btn outlined class="custom-button-primary" v-else
                           style="height: 36px;min-width: 42px;padding: 0"
                           @click="prepareDraft">
                        <v-icon color="primary">edit</v-icon>
                    </v-btn>

                    <v-btn outlined class="custom-button-primary"
                           style="height: 36px;min-width: 42px;padding: 0"
                           :to="openFormUrl"
                    >
                        <v-icon color="primary">remove_red_eye</v-icon>
                    </v-btn>
                </div>
            </div>

            <div class="row">
                <div class="col-4">
                    <v-img :src="imgSrc" @error="checkSrc()"
                           v-if="informationData">
                    </v-img>
                </div>

                <div class="col-8 d-flex flex-column">
                    <div class="mb-2" v-if="informationData && informationData.phone">
                        <v-icon class="text-primary" left>phone</v-icon>
                        <span class="mt-auto mb-auto">{{ informationData.phone }}</span>
                    </div>
                    <div :class="informationData.close !== null? 'mb-2': 'mb-0'"
                         v-if="informationData && informationData.address && informationData.commune">
                        <v-icon class="text-primary" left>place</v-icon>
                        <span class="mt-auto mb-auto">{{ informationData.address }} {{ informationData.commune }}</span>
                    </div>
                    <div v-if="informationData && informationData.close !== null">
                        <v-icon class="text-primary" left>schedule</v-icon>
                        <span class="mt-auto mb-auto" v-if="informationData.close">Fermé aujourd'hui</span>
                        <span class="mt-auto mb-auto"
                              v-if="informationData.hours && informationData.hours.length > 0 && !informationData.close">
                            Ouvert de {{ formatHour(informationData.hours[0].open) }}
                            à {{ formatHour(informationData.hours[0].close) }}
                            <span v-if="informationData.hours.length > 1">
                                et de {{ formatHour(informationData.hours[1].open) }}
                            à {{ formatHour(informationData.hours[1].close) }}</span>
                        </span>
                        <span v-else-if="!informationData.close">
                            Ouvert aujourd'hui
                        </span>
                    </div>
                    <div class="m-0 d-flex" v-if="informationData &&
                    (informationData.web_site || informationData.google || informationData.facebook ||
                    informationData.youtube || informationData.instagram)">
                        <v-icon class="text-primary mr-3" left>link</v-icon>
                        <div class="row">
                            <div class="col-1 mt-auto mb-auto" v-if="informationData.web_site">
                                <a :href="informationData.web_site" target="_blank">
                                    <v-icon color="#37bcde">language</v-icon>
                                </a>
                            </div>
                            <div class="col-1 mt-auto mb-auto" v-if="informationData.google">
                                <a :href="informationData.google" target="_blank">
                                    <v-img src="/images/mini_google.png" max-width="20px" :width="100"></v-img>
                                </a>
                            </div>
                            <div class="col-1 mt-auto mb-auto" v-if="informationData.facebook">
                                <a :href="informationData.facebook" target="_blank">
                                    <v-img src="/images/mini_facebook.png" max-width="20px" :width="120"></v-img>
                                </a>
                            </div>
                            <div class="col-1 mt-auto mb-auto" v-if="informationData.youtube">
                                <a :href="informationData.youtube" target="_blank">
                                    <v-img src="/images/mini_youtube.png" max-width="20px" :width="100"></v-img>
                                </a>
                            </div>
                            <div class="col-1 mt-auto mb-auto" v-if="informationData.instagram">
                                <a :href="informationData.instagram" target="_blank">
                                    <v-img src="/images/mini_insta.png" max-width="20px" :width="100"></v-img>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-2">
                    <div class="ml-4"
                         v-if="account.tis_type.code === 'DAHUB_QUEBEC' &&
                         informationData && informationData.last_updated_form && informationData.last_updated_form.date">
                        <span class="mt-auto mb-auto font-italic" style="color: #6c6b6b; font-size: 14px">
                            Modification le {{ formatDate(informationData.last_updated_form.date) }}
                            par {{ informationData.last_updated_form.user_first_name }}
                            {{ informationData.last_updated_form.user_name }}
                        </span>
                    </div>
                    <div v-if="account.tis_type.code === 'DAHUB_QUEBEC' && informationData &&
                    informationData.last_sync_date !== null"
                         class="mt-2 ml-4">
                        <span class="mt-auto mb-auto font-italic" style="color: #6c6b6b; font-size: 14px">
                            Dernière synchronisation Hawwwai le {{ formatDate(informationData.last_sync_date) }}
                        </span>
                    </div>
                </div>
            </div>
        </v-card>

        <v-dialog v-model="takeDraftModal" width="700px" v-if="draft !== null">
            <take-power-back-modal :draft="draft"></take-power-back-modal>
        </v-dialog>
    </div>
</template>

<script>
import TakePowerBackModal from "../../tools/TakePowerBackModal.vue"
import { mapState } from "vuex"

export default {
    name: "InformationBloc",
    components: { TakePowerBackModal },
    props: ["providerId", "openFormUrl", "lastSyncDate", "hasSitDraftForm", "vtUse"],
    data() {
        return {
            informationData: null,
            takeDraftModal: false,
            draft: null,
            imgSrc: "/images/empty_img.png",
        }
    },
    methods: {
        getInformations() {
            this.$http.get("auth/providers/" + this.providerId + "/informations").then(res => {
                this.informationData = res.body.data.informationResource

                if (this.informationData.first_media) {
                    this.imgSrc = this.informationData.first_media.thumbnail_url
                } else {
                    this.imgSrc = "/images/empty_img.png"
                }
            })
        },
        formatHour(hour) {
            let splited = hour.split(":")
            hour = splited[0] + ":" + splited[1]
            return hour
        },
        prepareDraft() {
            this.$http.get("sitform/check-draft/" + this.providerId).then(res => {
                if (res.body.success) {
                    this.$router.push({
                        path: "/sit/formulaire/" + this.providerId,
                        query: {
                            providerDataId: this.informationData.provider_data_id,
                            newDraft: true,
                        },
                    })
                } else {
                    let webForm = res.body.data.webForm
                    this.draft = {
                        user_name: webForm.user.last_name,
                        user_first_name: webForm.user.first_name,
                        user_id: webForm.user.id,
                        drafted_at: webForm.answer.drafted_at,
                        provider_data_id: webForm.answer.provider_data_versions[0].id,
                        web_form_id: webForm.id,
                        provider_id: this.providerId,
                    }

                    this.takeDraftModal = true
                }
            })
        },
        checkSrc() {
            if (this.imgSrc.includes("thumbnails")) {
                this.imgSrc = this.informationData.first_media.url
            } else {
                this.imgSrc = "/images/broken_img.png"
            }
        },
    },
    computed: {
        ...mapState("account", ["user", "account", "vtContract"]),
    },
    watch: {
        providerId() {
            if (this.providerId !== null) {
                this.getInformations()
            }
        },
    },
    created() {
        this.getInformations()

        this.$global.$on("close_take_power_back_modal", () => {
            this.takeDraftModal = false
        })
    },
}
</script>